export default function(values) {
    let errors = {};

    if (!values.DoorRoomId) {
        errors.DoorRoomId = "Please select a door room.";
    }

    if (!values.DoorTypeId) {
        errors.DoorTypeId = "Please select a door type.";
    }

    if (!values.DoorModelId) {
        errors.DoorModelId = "Please select a door model.";
    }

    if (!values.DoorColourId) {
        errors.DoorColourId = "Please select a door colour.";
    }

    if (!values.DoorHandleId) {
        errors.DoorHandleId = "Please select a door handle colour.";
    }

    if (!values.DoorStyleId) {
        errors.DoorStyleId = "Please select a door style.";
    }
    if (!values.DoorGlassId) {
        errors.DoorGlassId = "Please select a door glass.";
    }

    if (!values.DoorInteriorColourId) {
        errors.DoorInteriorColourId = "Please select an interior door colour.";
    }
    if (!values.DoorExteriorColourId) {
        errors.DoorExteriorColourId = "Please select an exterior door colour.";
    }
    if (!values.DoorFrameId) {
        errors.DoorFrameId = "Please select a door frame.";
    }
    if (!values.DoorHardwareColour && (values.DoorKnocker || values.DoorLetterbox)) {
        errors.DoorHardwareColour = "Please select a door hardware colour.";
    }

    if(!values.DoorHandleType){
        errors.DoorHandleType = "Please select a handle type.";
    }

    return errors;
}



// WEBPACK FOOTER //
// ./src/containers/DoorForm/validate.js